import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { containsText, Store } from '@softline/core';
import { Contact } from '../../data/contact.model';
import { Ticket } from '../../data/ticket.model';
import { InputComponent, ResolvableModal } from '@softline/ui-core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { SOFTLINE_FEATURE_TICKET_CONTACT, TicketContactStore } from '../../ticket.shared';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CheckboxComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-assign-ticket-dialog',
  imports: [
    CommonModule,
    FormsModule,
    CommonModule,
    FormsModule,
    CheckboxComponent,
    TranslatePipe,
    InputComponent,
  ],
  templateUrl: './assign-ticket-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./assign-ticket-dialog.component.css'],
})
export class AssignTicketDialogComponent extends ResolvableModal<any> {
  private store = inject(Store);

  ticket = input<Ticket>();
  contacts$ = this.store.observe(
    SOFTLINE_FEATURE_TICKET_CONTACT,
    TicketContactStore.getters.all
  );
  selectedContact?: Contact;

  // tslint:disable-next-line:variable-name
  private _filter$ = new BehaviorSubject<string>('');
  get filter(): string {
    return this._filter$.getValue();
  }
  set filter(value: string) {
    this._filter$.next(value);
  }

  // tslint:disable-next-line:variable-name
  private _delayedFilter$ = this._filter$.pipe(
    debounceTime(100),
    map((o) => (o.length >= 3 ? o : ''))
  );

  filteredContacts$ = combineLatest([this.contacts$, this._delayedFilter$]).pipe(
    map(([contacts, filter]) => {
      if (!filter) {
        return contacts;
      }
      return contacts.filter((o) => containsText(o, filter));
    })
  );

  onSubmit(contact?: Contact): void {
    this.resolve(contact);
  }
}
